import React from "react";

const getAccessTimingsTooltip = (windows = []) => {
  if (!windows?.length) return "No access timings available";

  return windows
    .map((w) => {
      const parts = [];

      // City
      if (w.city) {
        parts.push(w.city);
      }

      // Day of week (optional)
      if (w.dayOfWeek) {
        parts.push(`(${w.dayOfWeek})`);
      }

      // Primary window
      if (w.startTime && w.endTime) {
        parts.push(`${w.startTime} - ${w.endTime}`);
      }

      // Secondary window (optional)
      if (w.secondStartTime && w.secondEndTime) {
        parts.push(`| ${w.secondStartTime} - ${w.secondEndTime}`);
      }

      return parts.join(" ");
    })
    .join(" | ");
};

export function SiteAccessibleCell(props) {
  const {
    isSiteAccessible,
    followsCustomerServiceWindow,
    serviceWindows,
    customerServiceWindows,
  } = props.dataItem;

  if (!isSiteAccessible) {
    return <td />;
  }

  const isYes = isSiteAccessible === "Yes";

  const bgColor = isYes ? "#2A9D8F" : "#E63946";
  const textColor = "#FFFFFF";

  // choose correct windows
  const windowsToUse = followsCustomerServiceWindow
    ? customerServiceWindows
    : serviceWindows;

  const tooltip = getAccessTimingsTooltip(windowsToUse);

  return (
    <td>
      <div className="flex items-center justify-center">
        <div
          title={`Access Timings: ${tooltip}`}
          className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border cursor-default"
          style={{
            width: "100px",
            backgroundColor: bgColor,
            color: textColor,
          }}
        >
          {isSiteAccessible}
        </div>
      </div>
    </td>
  );
}
